import { jwtDecode } from "jwt-decode";
import { msalInstance } from "..";
import { loginRequest } from "../auth/auth-config";
import { InteractionRequiredAuthError } from "@azure/msal-browser";


export const getToken = async (scopes: string[]) => {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        console.error("No active account found.");
        return null;
    }
        try {
        const response = await msalInstance.acquireTokenSilent({
            account: account,
            scopes: scopes,
        });
        return response.accessToken;
    } catch (error) {
        console.error("Token acquisition failed: ", error);
        if(error instanceof InteractionRequiredAuthError){
        try {
            const response = await msalInstance.acquireTokenPopup({
                account: account,
                scopes: scopes,
            });
            return response.accessToken;
        } catch(popupError){
            console.error("Popup token acquisition also failed: ",popupError);
        }
    }
    try{
        console.warn("Attempting full login..");
        const loginResponse=await msalInstance.loginPopup(loginRequest);
        if(loginResponse.account){
        msalInstance.setActiveAccount(loginResponse.account);
        return await getToken(scopes);
        }
    } catch(loginError){
        console.error("Login attempt failed", loginError);
        return null;
    }
}
};

export const getUserRole = async () => {
    let accessToken = await getToken(loginRequest.scopes);
    if (accessToken) {
        const decoded: any = jwtDecode(accessToken);
        
        // Check if roles is undefined or an empty array
        if (!decoded?.roles || decoded.roles.length === 0) {
            console.log("User => No User Role");
            return "noAccess";
        } else {
            const userRole = decoded.roles[0]; // Get the first role
            console.log("User =>", userRole);
            return userRole;
        }
    } else {
        console.error("Access token is not available");
        return "noAccess"; // Handle the case where the token is not available
    }
};
export const getUserMailID = async () => {
    const account = msalInstance.getActiveAccount();
    const user_mailID = account?.username;
    return user_mailID;
  };

